import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.css']
})
export class PageNotFoundComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/components/page-not-found/page-not-found.component.ts